<script>
import popupModel from '@/model/popup';
import ImageSlider from '@/components/ui/ImageSlider.vue';

export default {
  name: 'ImageSliderWrap',
  components: { ImageSlider },
  props: {
    items: Array,
  },
  computed: {
    images() { return this.items.map(f => f.file.thumbnails.preview_xl); },
  },
  methods: {
    // полноэкранный просмотр — через диспетчер попапов (BasePreview)
    openPreview(index) {
      const items = this.items.map(f => ({ type: 'image', src: f.file.url }));
      popupModel.addPreview(items, index);
    },
  },
}
</script>

<template lang="pug">
.b-image-slider-wrap
  ImageSlider(:items="images" @preview="openPreview")
</template>

<style scoped lang="scss">

</style>
